var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.32562 10.8189L3.27934 6.77264C2.90689 6.40019 2.90689 5.79633 3.27934 5.42388C3.65179 5.05143 4.25565 5.05143 4.6281 5.42388L8 8.79578L11.3719 5.42387C11.7444 5.05142 12.3482 5.05142 12.7207 5.42387C13.0931 5.79632 13.0931 6.40018 12.7207 6.77263L8.67667 10.8166C8.67591 10.8174 8.67515 10.8182 8.67438 10.8189C8.30193 11.1914 7.69807 11.1914 7.32562 10.8189Z",
    fill: "#002240"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron-down.9934d3835d869e9b4bed5686e04b87d0.svg";
export { ForwardRef as ReactComponent };